import React, { useState } from 'react';
import classnames from 'classnames';
import TinyEditor from '@gp/components/TinyEditor';
import { noop } from '@gp/utils/common';

import './index.scss';

interface IPPSCommentEditProps {
  text: string;
  onChange: (v: string) => void;
}

const PPSCommentEdit: React.FC<IPPSCommentEditProps> = (props) => {
  const { text = '', onChange = noop } = props;

  const [isWangEditorFocused, setIsWangEditorFocused] = useState<boolean>(false);

  return (
    <div className="dbg-all-projects-pps-comment-edit">
      <TinyEditor
        className={classnames('gp-word-break-word', { 'dbg-blue-border': isWangEditorFocused })}
        placeholder="Please input Comments"
        value={text}
        getEditorContent={onChange}
        getIsFocused={(v: boolean) => setIsWangEditorFocused(v)}
      />
    </div>
  );
};

export default React.memo(PPSCommentEdit);
